var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import React from 'react';
import { useResourceContext, useNotify, useUpdate, } from 'react-admin';
export var useDatagridAGEditController = function (props) {
    var editType = props.editType, _a = props.mutationOptions, mutationOptions = _a === void 0 ? {} : _a, onCellEditRequestProp = props.onCellEditRequest, onRowEditingStartedProp = props.onRowEditingStarted, onRowEditingStoppedProp = props.onRowEditingStopped;
    var notify = useNotify();
    var resource = useResourceContext();
    // cell editing
    var _b = mutationOptions.mutationMode, mutationMode = _b === void 0 ? 'pessimistic' : _b, meta = mutationOptions.meta, otherMutationOptions = __rest(mutationOptions, ["mutationMode", "meta"]);
    var defaultOnError = React.useCallback(function (error) {
        notify(typeof error === 'string'
            ? error
            : error.message || 'ra.notification.http_error', { type: 'warning' });
    }, [notify]);
    var update = useUpdate(resource, { meta: meta }, __assign({ onError: defaultOnError, mutationMode: mutationMode }, otherMutationOptions))[0];
    // Custom row update logic, to trigger only 1 update call when using fullRow editType
    var editedRowPreviousData = React.useRef();
    var editedRowNewData = React.useRef();
    var onRowEditingStarted = React.useCallback(function (event) {
        onRowEditingStartedProp && onRowEditingStartedProp(event);
        if (editType !== 'fullRow') {
            return;
        }
        editedRowPreviousData.current = cloneDeep(event.data);
        editedRowNewData.current = cloneDeep(event.data);
    }, [editType, onRowEditingStartedProp]);
    var onCellEditRequest = React.useCallback(function (event) {
        onCellEditRequestProp && onCellEditRequestProp(event);
        if (editType !== 'fullRow') {
            var newData = set(cloneDeep(event.data), event.colDef.field, event.newValue);
            update(undefined, {
                id: event.data.id,
                data: newData,
                previousData: event.data,
            });
        }
        else {
            if (editedRowNewData.current) {
                editedRowNewData.current = set(editedRowNewData.current, event.colDef.field, event.newValue);
            }
        }
    }, [editType, update, onCellEditRequestProp]);
    var onRowEditingStopped = React.useCallback(function (event) {
        onRowEditingStoppedProp && onRowEditingStoppedProp(event);
        if (editType !== 'fullRow') {
            return;
        }
        update(undefined, {
            id: event.data.id,
            data: editedRowNewData.current,
            previousData: editedRowPreviousData.current,
        });
    }, [editType, update, onRowEditingStoppedProp]);
    return {
        onRowEditingStarted: onRowEditingStarted,
        onRowEditingStopped: onRowEditingStopped,
        onCellEditRequest: onCellEditRequest,
    };
};
